import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useSharedLoan } from 'context/SharedLoanContext'
import { useEffect, useState } from 'react'
import { getServicingDefaultTracking, postServicingDefaultTracking } from 'services'
import { InputConvert, InputValidate, openAuditLog } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { ServicingNoteFields } from '../ServicingNoteFields'

export default function DefaultTracking() {
  const shared = useSharedLoan()
  const isShared = !!shared?.readOnly
  const [loading, setLoading] = useState(false)
  const [valueChanged, setValueChanged] = useState(false)
  const [inputs, setInputs] = useState<any>({})

  const init = async () => {
    setLoading(true)
    const res = await getServicingDefaultTracking()
    if (res.success) {
      setInputs(res.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (isShared) {
      const res = shared.pageData as any
      if (res?.data) setInputs(res.data)
      else if (res && typeof res === 'object') setInputs(res)
      return
    }
    init()
  }, [isShared, shared?.pageKey, shared?.pageData])

  const onChange = async (key: string, e: any) => {
    if (isShared) return
    let value = InputConvert(inputs[key], e)
    let temp = cloneDeep(inputs)
    if (key == 'files') {
      setLoading(true)
      await postServicingDefaultTracking({ [key]: value })
      setLoading(false)
    }
    temp[key].value = value
    temp[key].error = InputValidate(temp[key])
    setInputs(temp)
    setValueChanged(true)
  }

  const onBlur = async (key: string) => {
    if (isShared || !valueChanged) return
    if (inputs[key].error?.length > 0) return
    setValueChanged(false)
    setLoading(true)
    await postServicingDefaultTracking({ [key]: inputs[key].value })
    setLoading(false)
  }

  const showHistory = async (key: string) => {
    if (isShared) return
    const options = {
      table: 'ServicingDefaultTracking',
      field: key,
      keys: {
        field: key,
      },
    }
    openAuditLog(options)
  }

  return (
    <div className="DefaultTracking-Container relative">
      <h2 className="text-2xl flex items-center gap-1 font-bold mb-2">
        <span>Default Tracking</span>
      </h2>
      <LayoutLoading show={loading} />
      <ServicingNoteFields kind="noticeOfDefault" readOnly={isShared} />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {Object.keys(inputs).map((key, index) => {
          let input = inputs[key]
          input.disabled = loading || isShared
          input.readOnly = isShared
          return (
            <div className={`md:col-span-${input.span || 1}`} key={index}>
              <RenderInput
                input={input}
                Key={key}
                onChange={onChange}
                onBlur={onBlur}
                showHistory={isShared ? undefined : showHistory}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
